import { Button, ButtonProps } from '@mui/material';
import { Euro } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type SttButtonCollectProps = {
    caption?: string;
    onClick: () => void;
} & ButtonProps;

/**
 * Accept button
 */
export function SttButtonCollect({
    caption,
    onClick,
    ...rest
}: SttButtonCollectProps) {
    const { t } = useTranslation();

    return (
        <Button
            {...rest}
            variant="contained"
            color="primary"
            startIcon={<Euro />}
            onClick={onClick}
        >
            {caption || t('Collect')}
        </Button>
    );
}
